var AdaptiveImage = require("../../react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "src/assets/web/images/powered_by_google_on_white.png","uri@2x": __webpack_public_path__ + "src/assets/web/images/powered_by_google_on_white.png","uri@3x": __webpack_public_path__ + "src/assets/web/images/powered_by_google_on_white.png",
    width: 144,
    height: 18
});